import React from "react"
import { TableHeader, TableRow, TableHeaderColumn } from "material-ui/Table"

import * as types from "components/person/types"


export default props => {
    switch (props.type) {
        case types.FLIGHT_ATTENDANT:
            return (
                <TableHeader displaySelectAll={ false }>
                    <TableRow>
                        <TableHeaderColumn></TableHeaderColumn>
                        <TableHeaderColumn>Rank</TableHeaderColumn>
                        <TableHeaderColumn>Daily Rate</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
            )
        case types.ENGINEER:
            return (
                <TableHeader displaySelectAll={ false }>
                    <TableRow>
                        <TableHeaderColumn></TableHeaderColumn>
                        <TableHeaderColumn>Rank</TableHeaderColumn>
                        <TableHeaderColumn>Years of Experience</TableHeaderColumn>
                        <TableHeaderColumn>Valid Until</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
            )
        default:
            return (
                <TableHeader displaySelectAll={ false }>
                    <TableRow>
                        <TableHeaderColumn></TableHeaderColumn>
                        <TableHeaderColumn>Rank</TableHeaderColumn>
                        <TableHeaderColumn>Hours</TableHeaderColumn>
                        <TableHeaderColumn>Valid Until</TableHeaderColumn>
                        <TableHeaderColumn>Daily Rate</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
            )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/person/Ratings/table-header.js
 **/